export enum Themes {
    light = "light", 
    dark = "dark"
}